import { AppleIcon, Button } from '@iheartjane/reefer';
import type { ButtonProps } from '@iheartjane/reefer';

interface AppleSignInButtonProps extends ButtonProps {
  label: string;
  onClick: () => void;
}

export const AppleSignInButton = ({
  label,
  onClick,
  ...buttonProps
}: AppleSignInButtonProps) => {
  return (
    <Button
      full
      label={label}
      onClick={onClick}
      startIcon={<AppleIcon size="sm" color={null} />}
      variant="tertiary"
      {...buttonProps}
    />
  );
};
